import React, { useState } from 'react';
import { CheckCheck, Loader2 } from 'lucide-react';
import { api } from '../../context/AuthContext';

const hm = (m) => `${Math.floor((m || 0) / 60)}:${String((m || 0) % 60).padStart(2, '0')}`;
const monatName = (m) => new Date(`${m}-01T12:00:00`).toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });

// Alle eingereichten Tage eines Mitarbeiters im Monat mit Rückfrage festschreiben.
export const MonatFestschreiben = ({ uid, name, monat, daten, minuten, toast, onDone, klein }) => {
  const [busy, setBusy] = useState(false);
  if (!daten.length) return null;
  const los = async () => {
    if (!window.confirm(`Ganzen Monat ${monatName(monat)} für ${name} festschreiben?\n\n${daten.length} eingereichte Tag(e) · ${hm(minuten)} Std.\n\nNicht eingereichte Tage bleiben offen. Der Mitarbeiter erhält eine Bestätigung.`)) return;
    setBusy(true);
    try {
      const r = await api.post('/admin/zeiterfassung/festschreiben', { user_id: uid, daten, aktion: 'festschreiben' });
      toast({ title: `${r.data.geaendert} Tag(e) festgeschrieben` });
      onDone();
    } catch (e) { toast({ title: e?.response?.data?.detail || 'Fehler', variant: 'destructive' }); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={los} disabled={busy} className={`inline-flex items-center gap-1.5 rounded-[10px] bg-emerald-700 text-white disabled:opacity-50 ${klein ? 'h-8 px-3 text-xs' : 'h-10 px-4 text-sm'}`} data-testid={`az-monat-fest-${uid}`}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCheck className="w-4 h-4" />} {klein ? 'Monat festschreiben' : 'Ganzen Monat festschreiben'} ({daten.length})
    </button>
  );
};
